module.exports = __webpack_public_path__ + "static/media/marker_vl.0c75b911.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_vl.svg
// module id = 244
// module chunks = 0